import React, { useState, useEffect } from "react";
import "./Reporting.css";
import { useNavigate } from "react-router-dom";
import { db, storage } from "../firebase";
import { collection, doc, query, where, getDocs, updateDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

const Reporting = () => {
  const navigate = useNavigate();
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [actionPlan, setActionPlan] = useState([]);
  const [inputs, setInputs] = useState({});

  useEffect(() => {
    if (sessionStorage.getItem("login") !== "true") {
      navigate("/");
    }
  }, []);

  const name = localStorage.getItem("empname");
  const empId = localStorage.getItem("empid");

  useEffect(() => {
    if (!month) return;

    const fetchActionPlan = async () => {
      try {
        const q = query(
          collection(db, "actionplan"),
          where("empid", "==", empId),
          where("month", "==", String(month + " " + year)),
          where("budgetapproved", "!=", 0)
        );
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
          setActionPlan([]);
          return;
        }

        const actions = [];
        const inputValues = {};

        querySnapshot.forEach((doc) => {
          const data = doc.data();
          const id = doc.id;

          actions.push({
            id,
            code: data.programCode || "",
            text: data.program || "",
            type: data.notesheettype
          });

          inputValues[id] = {
            campus: data.campus || "On Campus", // Default to "On Campus" if not set
            days: data.days || 0,
            prgvenue: data.prgvenue || "",
            scm: data.scm || 0,
            scf: data.scf || 0,
            stm: data.stm || 0,
            stf: data.stf || 0,
            othm: data.othm || 0,
            othf: data.othf || 0,
            total: data.total || 0,
            picurl: data.picurl || "",
            tsurl: data.tsurl || "",
          };
        });

        setActionPlan(actions);
        setInputs(inputValues);
      } catch (error) {
        console.error("Error fetching action plans:", error);
      }
    };

    fetchActionPlan();
  }, [month, year]);

  const handleChange = (id, field, value) => {
    let newValue = ["scm", "scf", "stm", "stf", "othm", "othf"].includes(field)
      ? value || 0
      : value;

    const updatedInputs = {
      ...inputs,
      [id]: {
        ...inputs[id],
        [field]: newValue,
      },
    };

    // Calculate total for numerical fields
    if (["scm", "scf", "stm", "stf", "othm", "othf"].includes(field)) {
      const { scm, scf, stm, stf, othm, othf } = updatedInputs[id];
      updatedInputs[id].total = parseInt(scm || 0) + parseInt(scf || 0) + parseInt(stm || 0) + parseInt(stf || 0) + parseInt(othm || 0) + parseInt(othf || 0);
    }

    setInputs(updatedInputs);
  };

  const handleFileUpload = async (id, file, type) => {
    if (!file) return;

    const fileRef = ref(storage, `uploads/${id}/${type}_${file.name}`);
    await uploadBytes(fileRef, file);
    const fileURL = await getDownloadURL(fileRef);

    setInputs((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [type]: fileURL,
      },
    }));

    return fileURL;
  };

  const handleSave = async (id) => {
    try {
      const dataToSave = {
        ...inputs[id],
        scm: Number(inputs[id].scm) || 0,
        scf: Number(inputs[id].scf) || 0,
        stm: Number(inputs[id].stm) || 0,
        stf: Number(inputs[id].stf) || 0,
        othm: Number(inputs[id].othm) || 0,
        othf: Number(inputs[id].othf) || 0,
        total: Number(inputs[id].total) || 0,
        days: Number(inputs[id].days) || 0,
      };

      const actionRef = doc(db, "actionplan", id);
      await updateDoc(actionRef, dataToSave);
      alert("Saved successfully!");
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };
  const handleBack = (e) => {
    e.preventDefault();
    navigate(-1)
  }
  return (
    <div className="container">
      <h1 className="welcome">Program Report of {name || "User"}</h1>

      <div style={{ display: "flex", flexDirection: "row" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label className="label">Select Month and Year:</label>
          <select
            className="dropdown"
            id="dd1"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
          >
            <option value="">Month</option>
            {[
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ].map((m) => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </div>
        <select
          className="dropdown"
          id="dd2"
          value={year}
          onChange={(e) => setYear(e.target.value)}
          style={{ width: "150px", height: "40px", marginTop: "33px" }}
        >
          <option value="">Year</option>
          {["2025", "2026", "2027", "2028"].map((m) => (
            <option key={m} value={m}>{m}</option>
          ))}
        </select>
      </div>

      {actionPlan.length > 0 && (
        <div className="action-section">
          <table className="action-table">
            <thead>
              <tr>
                <th>Code</th>
                <th>Program Name</th>
                <th>Days</th>
                <th style={{ width: '60px' }}>Campus</th> {/* Adjusted width, removed !important */}
                <th>Venue</th>
                <th>SC(M)</th>
                <th>SC(F)</th>
                <th>ST(M)</th>
                <th>ST(F)</th>
                <th>OTH(M)</th>
                <th>OTH(F)</th>
                <th>Total</th>
                <th>Action Photo</th>
                <th ><p style={{ fontSize: '12px'}}>Trg-Distribution Sheet Action Report</p></th>
                <th>Save</th>
              </tr>
            </thead>
            <tbody>
              {actionPlan.map((action) => (
                <tr key={action.id}>
                  <td>{action.code}</td>
                  <td>{action.text}</td>
                  <td>
                    <input
                     // disabled={action.code.toLowerCase().includes("trg") ? false : true}
                      type="number"
                      style={{ width: "40px" }}
                      value={inputs[action.id]?.days || ""}
                      onChange={(e) => handleChange(action.id, "days", e.target.value)}
                    />
                  </td>
                  <td style={{ width: '60px' }}>
                    <select
                     // disabled={action.code.toLowerCase().includes("trg") ? false : true}
                      value={inputs[action.id]?.campus || "On Campus"}
                      onChange={(e) => handleChange(action.id, "campus", e.target.value)}
                      style={{ width: '60px' }} // Match the column width
                    >
                      <option value="On Campus">On</option>
                      <option value="Off Campus">Off</option>
                    </select>
                  </td>
                  <td>
                    <input
                      //disabled={action.code.toLowerCase().includes("trg") ? false : true}
                      type="text"
                      style={{ width: "100px" }}
                      value={inputs[action.id]?.prgvenue || ""}
                      onChange={(e) => handleChange(action.id, "prgvenue", e.target.value)}
                    />
                  </td>
                  {["scm", "scf", "stm", "stf", "othm", "othf"].map((field) => (
                    <td key={field}>
                      <input
                        //disabled={action.code.toLowerCase().includes("trg") ? false : true}
                        defaultValue={0}
                        type="number"
                        style={{ width: "40px" }}
                        value={inputs[action.id]?.[field] || ""}
                        onChange={(e) => handleChange(action.id, field, e.target.value)}
                      />
                    </td>
                  ))}
                  <td>{inputs[action.id]?.total || 0}</td>
                  <td>
                    <input
                      type="file"
                      accept=".jpg,.jpeg,.png"
                      style={{ width: "90px" }}
                      onChange={async (e) => {
                        const fileURL = await handleFileUpload(action.id, e.target.files[0], "picurl");
                        if (fileURL) handleChange(action.id, "picurl", fileURL);
                      }}
                    />
                    {inputs[action.id]?.picurl && (
                      <a href={inputs[action.id].picurl} target="_blank" rel="noopener noreferrer">
                        Click to View
                      </a>
                    )}
                  </td>
                  <td>
                    <input
                      type="file"
                      accept=".pdf"
                      style={{ width: "90px" }}
                      onChange={async (e) => {
                        const fileURL = await handleFileUpload(action.id, e.target.files[0], "tsurl");
                        if (fileURL) handleChange(action.id, "tsurl", fileURL);
                      }}
                    />
                    {inputs[action.id]?.tsurl && (
                      <a href={inputs[action.id].tsurl} target="_blank" rel="noopener noreferrer">
                        Click to View
                      </a>
                    )}
                  </td>
                  <td>
                    <button onClick={() => handleSave(action.id)}>Save</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <img src="/assets/back.png" style={{ width: '100px' }} onClick={handleBack} alt="" />

    </div>
  );
};

export default Reporting;